import { useEffect } from 'react';
import { toast } from 'sonner';

const MySnackbar = ({ open, handleClose, duration = 3000, text }) => {
  useEffect(() => {
    if (open && text) {
      toast.success(text, {
        duration: duration,
        onDismiss: handleClose,
        onAutoClose: handleClose,
      });
    }
  }, [open, text, duration, handleClose]);

  return null; // Sonner handles the UI
};

export default MySnackbar;
